var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":_vm.btnVariant,"disabled":_vm.loading},on:{"click":_vm.whenClick}},[(_vm.loading)?_c('b-spinner',{attrs:{"small":""}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }